import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'
import 'croppie/croppie.css'
import './styles/index.scss'

import Vue from 'vue'
import Vuetify from 'vuetify'
import VTooltip from 'v-tooltip';

import App from './App'
import store from './store'
import router from './router'

Vue.use(VTooltip)
Vue.use(Vuetify, {
  theme: {
    primary: '#03A9F4',
    secondary: '#03A9F4',
    accent: '#FF5722',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  }
})

Vue.config.productionTip = process.env.NODE_ENV === 'production'

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
